// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1__f36d00e7b0b637d50e37","cls2":"CreateSocialItemModal-cls2__cf997144bcc7c52b8c54 CreateSocialItemModal-cls1__f36d00e7b0b637d50e37"};